<template>
  <main>
    <div data-scroll-el="pdpContainer" />
    <div :class="{ 'fit-finder-container': $feature.showFitFinderOnPDP }">
      <slot name="notifications" />
      <transition name="fade">
        <div v-if="productPending && !product">
          <pdp-skeleton />
        </div>
        <div v-else-if="product">
          <div class="lg:mb-10 lg:flex lg:items-start">
            <section class="relative lg:grow" data-scroll-el="gallery">
              <pdp-section-breadcrumbs
                class="absolute left-0 top-0 z-1 m-2 rounded-xs bg-grey-80 bg-op-80 px-2 py-1 lg:!hidden"
              />
              <slot name="gallery" />
            </section>
            <section
              v-style="{ w: { lg: '30rem' }, top: { lg: '6rem' } }"
              class="px-4 lg:sticky lg:shrink-0 lg:px-6 lg:pt-12 space-y-2"
            >
              <div class="f-col gap-4 <lg:hidden">
                <slot name="breadcrumbs" />
                <slot name="heading" />
                <slot name="paypal-payments" />
              </div>
              <pdp-section-gift-card v-if="isDigitalProduct">
                <div class="mt-4 b-t b-grey-70 pt-4 lg:hidden">
                  <slot name="heading" />
                  <slot name="paypal-payments" />
                </div>
              </pdp-section-gift-card>
              <pdp-section-variant-selection v-else>
                <div class="mt-4 b-t b-grey-70 pt-4 lg:hidden">
                  <slot name="heading" />
                  <slot name="paypal-payments" />
                </div>
              </pdp-section-variant-selection>
              <div v-if="!$viewport.lg" class="mt-4">
                <slot name="buy-with-prime" />
              </div>
              <slot name="espot-below-sizes" />
              <slot name="ctas" />
              <div class="w-full space-y-2">
                <pdp-section-apple-pay v-if="!isComingSoon && !isRobisOnly" />
                <div class="mb-4 flex between">
                  <!-- todo: create slots for 'size-chart' and 'find-in-store' -->
                  <pdp-section-size-chart v-if="!isDigitalProduct && showSizeAndFit" />
                  <pdp-section-find-in-store v-if="!isDigitalProduct" />
                </div>
                <slot v-if="$viewport.lg" name="buy-with-prime" />
              </div>
              <slot name="upsells" />
              <slot name="shipping-methods" />
            </section>
          </div>
          <div
            v-if="!isDigitalProduct"
            v-style:mx="{ lg: '4rem' }"
            class="px-4 pb-10 lg:px-6 lg:pb-16 <lg:pt-10"
          >
            <slot name="accordions" />
            <slot name="espot-below-accordions" />
          </div>
          <slot name="shop-the-look" />
          <slot name="recommendations" />
          <slot name="espot-lazy-below-gallery" />
          <slot name="reviews" />
          <slot name="espot-lazy-above-footer" />
        </div>
      </transition>
    </div>
    <client-only>
      <teleport to="body">
        <slot name="body" />
      </teleport>
    </client-only>
    <slot />
  </main>
</template>

<script setup lang="ts">
import type { Slots } from '#commerce/types/pdp'

defineSlots<Slots>()

const { isComingSoon, isDigitalProduct, isRobisOnly, product, productPending, showSizeAndFit } = usePdp()
</script>
